interface ErrorType {
  path: string
  message: string
}

export async function handleNetworkError<T extends ErrorType>(
  request: () => Promise<T[]>,
  domain: string
): Promise<T[]> {
  try {
    return await request()
  } catch (e: any) {
    if (e.message?.toLowerCase().indexOf('failed to fetch') >= 0) {
      return [
        {
          path: '_',
          message: `
There was a problem connecting to the server. Please check your internet connection. If all seems well, then it is likely your organization has blocked access to Educator Pro Connect's API domain. 
\n\nPlease contact your IT department and ask for ${domain} to be whitelisted. Once that's done, you'll be able to use Educator Pro Connect to its full potential.`,
        } as T,
      ]
    }
    return [{ path: '_', message: e.message } as T]
  }
}
